import { get, post } from 'utils/rxfetch'

export default () => ({
  fetchAccountInvestigationData(body) {
    return post('/members-api/search/ato_investigation/', body)
  },
  fetchAccountInvestigationDepartments(companyFilter = '') {
    return get(`/members-api/profiles/departments?companyFilter=${companyFilter}`)
  },
  createAccountInvestigationIncident(companyFilter = '', alertId) {
    return post(`/members-api/search/ato_investigation/alerts/${alertId}/create_incident`, {
      company_ids: companyFilter,
    })
  },
})
